import {TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid, IconButton, CircularProgress} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {TAB_MISSING, TAB_MONTH_MISSING} from './StatsCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getShortSpecName} from '../Trans.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';

const StatsMonthMissing = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let pos = 0;

	function statsMonthMissingGetSpecName(spec_id) {
		const spec = gStorage.lists.speclist.list.find((x) => x.id === spec_id);

		return getShortSpecName(spec, gStorage.conn.user);
	}

	function copyToClipboard() {
		let cpText = '';

		gStorage.stats.obsList.forEach((item, i) => {
			if (i < 50) {
				if (cpText.length)
					cpText += ', ';

				cpText += statsMonthMissingGetSpecName(item.taxon);
			}
		});

		navigator.clipboard.writeText(cpText);
	}

	function statsMonthMissingCountryChange(event) {
		const country = gStorage.lists.countrylist.find(c => c.id === event.target.value);

		gStorage.stats.setCountry(country);
		gStorage.stats.setCity(null);
		gStorage.stats.setObsList(null);
	}

	function statsMonthMissingMonthChange(event) {
		const m = parseInt(event.target.value, 10);

    		gStorage.stats.setMonth(m);
		gStorage.stats.setObsList(null);
	}

	function statsMonthMissingRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('statsMonthMissingRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('statsMonthMissingRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_MONTH_MISSING)
			return;

		// console.log('statsMonthMissingRxWs', msg);

		gStorage.stats.setObsList(msg.data.monthmissing);
	}

	function loadMonthMissing() {
		// console.log('gStorage.gps.pos.accuracy', gStorage.gps.pos.accuracy);

		const msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'month',
			op: 'missing',
			data: {
				country: gStorage.stats.country.id,
				user: gStorage.conn.user.id,
				month: gStorage.stats.month,
				lon: Math.floor(gStorage.gps.pos.longitude * 1000000),
				lat: Math.floor(gStorage.gps.pos.latitude * 1000000)
			}
		};

		// console.log('loadMonthMissing', msg);
		
		gStorage.conn.ws.send(msg, statsMonthMissingRxWs);
	}

	if (gStorage.stats.tab !== TAB_MISSING || gStorage.stats.missing_tab !== TAB_MONTH_MISSING)
		return null;

	if (!gStorage.stats.month && gStorage.conn.online) {
		gStorage.stats.setMonth(new Date().getMonth() + 1);
		gStorage.stats.setObsList(null);
	}

	if (!gStorage.stats.obsList && gStorage.conn.online) {
		loadMonthMissing();

		return (
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<CircularProgress sx={{mt: 10}} />
			</Grid>
		);
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{
						country: {
							onChange: statsMonthMissingCountryChange,
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
					time = {{
						month: {
							month: gStorage.stats.month,
							onChange: statsMonthMissingMonthChange,
							enabled: gStorage.conn.online
						},
					}}
				/>
			</Grid>

			{gStorage.stats.obsList && 
				<TableContainer component={Paper} elevation={0} style={{width: 300, margin: 2}}>
					<Table size='small'>
						<TableHead>
							<TableRow>
								<TableCell padding='none'>#</TableCell>
								<TableCell>{t('stats._species')}</TableCell>
								<TableCell>
									<IconButton edge="start" color="inherit" onClick={copyToClipboard} aria-label="close">
										<ContentCopyIcon />
									</IconButton>
								</TableCell>
								<TableCell align='right'>{t('stats.score')}</TableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{gStorage.stats.obsList.map((elem, ind) => {
								if (elem.score <= 1) 
									return null;

								pos += 1;

								return (
									<TableRow key={ind}>
										<TableCell padding='none'>{pos}</TableCell>
										<TableCell colSpan={2}>{statsMonthMissingGetSpecName(elem.taxon)}</TableCell>
										<TableCell align='right'>{elem.score}</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			}
		</Grid>
	)
});

export default StatsMonthMissing;
